import React, { useEffect, useState } from "react";
import { authorizedGet } from "../../../Config/networkWithToken";
import MessageBar, { config, errorNotify } from "../../../utils/helper";
import configuration from "../../../Config/configuration";
import Spinner from "../../../Components/Spinner/Spinner";
import { FaArrowAltCircleLeft } from "react-icons/fa";

const AdminActivityLog = () => {
  const today = new Date().toISOString().split("T")[0];
  const [dates, setDates] = useState("today");
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [adminLoading, setAdminLoading] = useState(false);
  const [allAdmins, setAllAdmins] = useState([]);
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [activityData, setActivityData] = useState([]);
  const [requestType, setRequestType] = useState("acceptedRequests");
  const [matchType, setMatchType] = useState("suggestions");
  const [questionnaireType, setQuestionnaireType] = useState("approved");
  const [activeType, setActiveType] = useState("accepted");
  const [statusType, setStatusType] = useState("changed");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 10;
  const [isApply, setIsapply] = useState(false);

  const fetchAllAdmins = async () => {
    try {
      setAdminLoading(true);
      const url = `${configuration?.apis?.getAllAdmins}`;
      const res = await authorizedGet(url, config);
      const response = res?.data?.data;
      if (response) {
        setAllAdmins(response);
      }
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message ??
        (err?.request ? "Network error" : "An unexpected error occurred");
    } finally {
      setAdminLoading(false);
    }
  };

  const fetchProfileActivityData = async (filters = {}) => {
    try {
      setLoading(true);

      const params = new URLSearchParams();
      if (filters.adminId) params.append("adminId", filters.adminId);
      if (filters.dateFilter) params.append("dateFilter", filters.dateFilter);
      if (filters.startDate) params.append("startDate", filters.startDate);
      if (filters.endDate) params.append("endDate", filters.endDate);

      const url = `${configuration.apis.adminactivity}?${params.toString()}`;

      const res = await authorizedGet(url, config);
      const response = res?.data?.data;

      if (response) {
        setActivityData(response);
        setCurrentPage(1);
      }
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message ??
        (err?.request ? "Network error" : "An unexpected error occurred");
    } finally {
      setLoading(false);
    }
  };

  const handleBackToAdminList = () => {
    setSelectedAdmin(null);
    setDates("today");
    setStartDate("");
    setEndDate("");
    setIsapply(false);
    setActivityData([]);
  };
  useEffect(() => {
    fetchAllAdmins();
    // fetchProfileActivityData();
  }, []);

  const requestData = activityData?.requests?.[requestType] || [];
  const matchData = activityData?.matchess?.[matchType] || [];
  const questionnaireData =
    activityData?.questionaires?.[questionnaireType] || [];
  const noteData = activityData?.notes || [];
  const taskData = activityData?.taskNotes || [];
  const marryData = activityData?.marriedUsers || [];
  const blockData = activityData?.blockedUsers || [];
  const statusData = activityData?.userStatus?.[statusType] || [];
  const activeData = activityData?.userActive?.[activeType] || [];

  const maxLength = Math.max(
    requestData.length,
    matchData.length,
    questionnaireData.length,
    noteData.length,
    taskData.length,
    marryData.length,
    blockData.length,
    statusData.length,
    activeData.length,
  );
  const totalPages = Math.ceil(maxLength / ITEMS_PER_PAGE);

  const paginate = (data) =>
    data.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      currentPage * ITEMS_PER_PAGE,
    );

  const paginatedRequestData = paginate(requestData);
  const paginatedMatchData = paginate(matchData);
  const paginatedQuestionnaireData = paginate(questionnaireData);
  const paginatedNotesData = paginate(noteData);
  const paginatedTaskData = paginate(taskData);
  const paginatedMarryData = paginate(marryData);
  const paginatedBlockData = paginate(blockData);
  const paginatedStatusData = paginate(statusData);
  const paginatedActiveData = paginate(activeData);

  const currentPageDataLength = Math.max(
    paginatedRequestData.length,
    paginatedMatchData.length,
    paginatedQuestionnaireData.length,
    paginatedNotesData.length,
    paginatedTaskData.length,
    paginatedMarryData.length,
    paginatedBlockData.length,
    paginatedStatusData.length,
    paginatedActiveData.length,
  );

  return (
    <div className="font-Poppins mx-auto w-full ">
      {!selectedAdmin ? (
        <div>
          <h1 className=" md:text-1xl pl-4 pt-4 text-xl font-semibold">
            Select an Admin to View Activity Log
          </h1>
          {adminLoading ? (
            <div className="flex h-40 items-center justify-center">
              <Spinner />
            </div>
          ) : (
            <div className="grid grid-cols-1 gap-4 p-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
              {allAdmins.map((admin) => (
                <div
                  key={admin._id}
                  onClick={() => {
                    setSelectedAdmin(admin);
                    fetchProfileActivityData({
                      adminId: admin._id,
                      dateFilter: "custom",
                      startDate: today,
                      endDate: today,
                    });
                  }}
                  className="cursor-pointer rounded-lg border bg-white p-4 shadow-sm transition hover:shadow-md"
                >
                  <h2 className="overflow-y-auto text-lg font-semibold text-textYellow">
                    {admin?.name}
                  </h2>
                  <p className="overflow-y-auto text-sm text-gray-600">
                    {admin?.email}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
      ) : (
        <div>
          <div className="flex h-full w-full flex-col gap-4">
            <div className="flex w-full flex-col gap-4 md:flex-row md:items-center md:justify-between">
              <div className="mb-4 flex items-center justify-between pl-4">
                <FaArrowAltCircleLeft
                  className="cursor-pointer"
                  onClick={handleBackToAdminList}
                />
                <h1 className="md:text-1xl pl-4 text-xl font-semibold">
                  {selectedAdmin.name}'s Activity Log
                </h1>
              </div>
              <div className="flex w-full flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:gap-3 md:w-auto">
                <select
                  value={dates}
                  onChange={(e) => setDates(e.target.value)}
                  className="w-full cursor-pointer rounded-lg border px-3 py-2 text-sm shadow-sm outline-none sm:w-auto"
                >
                  <option value="today">Today</option>
                  <option value="thisWeek">This Week</option>
                  <option value="thisMonth">This Month</option>
                  <option value="thisYear">This Year</option>
                  <option value="q1">Q1 (Jan - Mar)</option>
                  <option value="q2">Q2 (Apr - Jun)</option>
                  <option value="q3">Q3 (Jul - Sep)</option>
                  <option value="q4">Q4 (Oct - Dec)</option>
                  <option value="h1">H1 (Jan - Jun)</option>
                  <option value="h2">H2 (Jul - Dec)</option>
                  <option value="custom">Custom Range</option>
                </select>

                {dates === "custom" && (
                  <div className="flex w-full flex-col sm:w-auto sm:flex-row sm:items-center sm:gap-2">
                    <input
                      type="date"
                      name="startDate"
                      id="startDate"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      className="w-full rounded border px-2 py-1 text-sm sm:w-auto"
                    />
                    <span className="text-center text-sm text-gray-600">
                      to
                    </span>
                    <input
                      type="date"
                      name="endDate"
                      id="endDate"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      className="w-full rounded border px-2 py-1 text-sm sm:w-auto"
                    />
                  </div>
                )}
                <button
                  className="w-full rounded-lg border bg-textYellow px-3 py-2 text-sm text-white shadow-sm outline-none sm:w-auto"
                  disabled={dates === "custom" && (!startDate || !endDate)}
                  onClick={() => {
                    const filters = {};
                    setIsapply(true);
                  
                    const currentYear = new Date().getFullYear();
                    let start, end;
                  
                    switch (dates) {
                      case "q1":
                        start = `${currentYear}-01-01`;
                        end = `${currentYear}-03-31`;
                        break;
                      case "q2":
                        start = `${currentYear}-04-01`;
                        end = `${currentYear}-06-30`;
                        break;
                      case "q3":
                        start = `${currentYear}-07-01`;
                        end = `${currentYear}-09-30`;
                        break;
                      case "q4":
                        start = `${currentYear}-10-01`;
                        end = `${currentYear}-12-31`;
                        break;
                      case "h1":
                        start = `${currentYear}-01-01`;
                        end = `${currentYear}-06-30`;
                        break;
                      case "h2":
                        start = `${currentYear}-07-01`;
                        end = `${currentYear}-12-31`;
                        break;
                      case "today":
                        filters.dateFilter = "custom";
                        filters.startDate = today;
                        filters.endDate = today;
                        break;
                      case "thisWeek":
                      case "thisMonth":
                      case "thisYear":
                        filters.dateFilter = dates;
                        break;
                      case "custom":
                        if (!startDate.trim() || !endDate.trim()) {
                          errorNotify("Please select both start and end dates.");
                          return;
                        }
                        filters.dateFilter = "custom";
                        filters.startDate = startDate;
                        filters.endDate = endDate;
                        break;
                      default:
                        break;
                    }
                  
                    // Set start/end if from quarter/half
                    if (start && end) {
                      filters.dateFilter = "custom";
                      filters.startDate = start;
                      filters.endDate = end;
                    }
                  
                    if (selectedAdmin?._id) {
                      filters.adminId = selectedAdmin._id;
                    }
                  
                    fetchProfileActivityData(filters);
                  }}
                  
                >
                  Apply
                </button>
                {isApply && (
                  <button
                    className="w-full rounded-lg border bg-red-700 px-3 py-2 text-sm text-white shadow-sm outline-none hover:bg-red-500 disabled:opacity-50 sm:w-auto"
                    onClick={() => {
                      setIsapply(false);
                      setDates("");
                      setStartDate("");
                      setEndDate("");
                      if (selectedAdmin?._id) {
                        setDates("today");
                        setStartDate("");
                        setEndDate("");
                        fetchProfileActivityData({
                          adminId: selectedAdmin._id,
                          dateFilter: "custom",
                          startDate: today,
                          endDate: today,
                        });
                      }
                    }}
                  >
                    Clear Filter
                  </button>
                )}
              </div>
            </div>
          </div>
          {loading ? (
            <div className="flex h-screen w-full items-center justify-center">
              <Spinner />
            </div>
          ) : currentPageDataLength > 0 ? (
            <div className="pb-4 pl-4 pt-4">
              <div className="overflow-x-auto rounded-lg bg-white shadow-md">
                <table className="min-w-full divide-y divide-gray-200 ">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
                        <select
                          value={requestType}
                          onChange={(e) => setRequestType(e.target.value)}
                          className="w-60 rounded border border-gray-300 px-2 py-1 text-sm capitalize"
                        >
                          <option value="acceptedRequests">
                            Accepted Requests
                          </option>
                          <option value="rejectedRequests">
                            Declined Requests
                          </option>
                        </select>
                      </th>

                      <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
                        <select
                          value={matchType}
                          onChange={(e) => setMatchType(e.target.value)}
                          className="w-60 rounded border border-gray-300 px-2 py-1 text-sm capitalize"
                        >
                          <option value="suggestions">Suggestions</option>
                          <option value="rejectedSuggestions">
                            Declined Suggestions
                          </option>
                        </select>
                      </th>

                      <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
                        <select
                          value={questionnaireType}
                          onChange={(e) => setQuestionnaireType(e.target.value)}
                          className="w-60 rounded border border-gray-300 px-2 py-1 text-sm capitalize"
                        >
                          <option value="approved">
                            Approved Questionnaires
                          </option>
                          <option value="rejected">
                            Declined Questionnaires
                          </option>
                        </select>
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
                        <select
                          value={statusType}
                          onChange={(e) => setStatusType(e.target.value)}
                          className="w-60 rounded border border-gray-300 px-2 py-1 text-sm capitalize"
                        >
                          <option value="changed">Status Changed</option>
                          <option value="updated">Status Updated</option>
                        </select>
                      </th>

                      <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
                        <select
                          value={activeType}
                          onChange={(e) => setActiveType(e.target.value)}
                          className="w-60 rounded border border-gray-300 px-2 py-1 text-sm capitalize"
                        >
                          <option value="accepted">Active Approved</option>
                          <option value="rejected">Active Declined </option>
                        </select>
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-medium uppercase text-gray-700">
                        <div className="w-60">Notes</div>
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-medium uppercase text-gray-700">
                        <div className="w-60">Task Notes</div>
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-medium uppercase text-gray-700">
                        <div className="w-60"> Marital Status</div>
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-medium uppercase text-gray-700">
                        <div className="w-60">Blocked Users</div>
                      </th>
                    </tr>
                  </thead>

                  <tbody className="divide-y divide-gray-200 bg-white">
                    {[...Array(currentPageDataLength)].map((_, i) => {
                      const req = paginatedRequestData[i];
                      const match = paginatedMatchData[i];
                      const quest = paginatedQuestionnaireData[i];
                      const note = paginatedNotesData[i];
                      const task = paginatedTaskData[i];
                      const marry = paginatedMarryData[i];
                      const block = paginatedBlockData[i];
                      const status = paginatedStatusData[i];
                      const active = paginatedActiveData[i];
                      const reqdata = req?.adminApprovedAt;
                      const reqrejectdata = req?.adminRejectedAt;
                      const matchdate = match?.sentAt;
                      const questdate = quest?.sentAt;
                      const statusupdatedate = status?.updatedAt;
                      const statuschangeddate = status?.changedAt;
                      const activedate = active?.activatedAt;
                      const rejectdate = active?.rejectedAt;
                      const blockdate = block?.blockedAt;
                      const marriedate = marry?.changedAt;
                      const notedate = note?.createdAt;
                      const tasknote = task?.createdAt;

                      return (
                        <tr key={i}>
                          <td className="px-4 py-4 text-sm text-gray-900">
                            <div className="flex flex-col gap-1 text-sm text-gray-700">
                              {req?.adminApproval && (
                                <span>
                                  Admin has{" "}
                                  <span className="font-semibold text-green-600">
                                    accepted
                                  </span>{" "}
                                  the request from{" "}
                                  <strong>{req?.senderName}</strong> ➝{" "}
                                  <strong>{req?.receivername}</strong>
                                </span>
                              )}

                              {req?.adminReject && (
                                <span>
                                  Admin has{" "}
                                  <span className="font-semibold text-red-600">
                                    declined
                                  </span>{" "}
                                  the request from{" "}
                                  <strong>{req?.senderName}</strong> ➝{" "}
                                  <strong>{req?.receivername}</strong>
                                </span>
                              )}

                              {req?.comments && (
                                <span>
                                  <span className="font-medium">Reason:</span>{" "}
                                  {req?.comments}
                                </span>
                              )}

                              {reqdata && req?.adminApproval && (
                                <span>
                                  <span className="font-medium">
                                    Accepted on:
                                  </span>{" "}
                                  {new Date(reqdata).toLocaleDateString()}
                                </span>
                              )}

                              {reqrejectdata && req?.adminReject && (
                                <span>
                                  <span className="font-medium">
                                    Declined on:
                                  </span>{" "}
                                  {new Date(reqrejectdata).toLocaleDateString()}
                                </span>
                              )}
                            </div>
                          </td>
                          {/* Suggestion data */}
                          <td className="px-4 py-4 text-sm text-gray-900">
                            <div className="flex flex-col gap-1">
                              {match && (
                                <span>
                                  Admin has given suggestion to{" "}
                                  <strong>{match.suggestedUserTo}</strong> ➝{" "}
                                  <strong>{match.suggestedUser}</strong>
                                </span>
                              )}

                              {/* Admin Decision */}
                              {match?.adminDecision && (
                                <span>
                                  Admin decision is{" "}
                                  <strong
                                    className={
                                      match.adminDecision === "reject"
                                        ? "text-red-600"
                                        : "text-green-600"
                                    }
                                  >
                                    {match.adminDecision}
                                  </strong>
                                </span>
                              )}

                              {match?.Userdecision && (
                                <span>
                                  User decision is {match.Userdecision}
                                </span>
                              )}
                              {match?.matchedUserdecision && (
                                <span>
                                  Matched user decision is{" "}
                                  {match.matchedUserdecision}
                                </span>
                              )}

                              {match?.adminDecision === "reject" &&
                                match?.adminRejectedComments && (
                                  <span>
                                    Reason: {match.adminRejectedComments}
                                  </span>
                                )}

                              {match?.sentAt && (
                                <span>
                                  Suggestion date:{" "}
                                  <strong>
                                    {new Date(
                                      match.sentAt,
                                    ).toLocaleDateString()}
                                  </strong>
                                </span>
                              )}
                            </div>
                          </td>
                          {/* Questionary data */}
                          <td className="px-4 py-4 text-sm text-gray-900">
                            <div className="flex flex-col gap-1">
                              {quest && (
                                <span>
                                  Admin has{" "}
                                  <span
                                    className={`font-semibold ${
                                      quest?.adminApproval === "approved"
                                        ? "text-green-600"
                                        : "text-red-600"
                                    }`}
                                  >
                                    {quest?.adminApproval === "approved"
                                      ? "approved"
                                      : "declined"}
                                  </span>{" "}
                                  the questionnaire request from{" "}
                                  <strong>{quest?.sender}</strong> ➝{" "}
                                  <strong>{quest?.sendTo}</strong>
                                </span>
                              )}

                              {quest && (
                                <span>{`AdminStatus: ${quest?.adminApproval}`}</span>
                              )}

                              {quest && (
                                <span>{`OverallStatus: ${quest?.overAllApproval}`}</span>
                              )}

                              {quest?.comments && (
                                <span>
                                  Declined Comment is{" "}
                                  <strong>{quest?.comments}</strong>
                                </span>
                              )}

                              {questdate && (
                                <span>
                                  Date:{" "}
                                  <strong>
                                    {new Date(questdate).toLocaleDateString()}
                                  </strong>
                                </span>
                              )}
                            </div>
                          </td>

                          {/* Status data */}
                          <td className="px-4 py-4 text-sm text-gray-900">
                            <div className="flex flex-col gap-1">
                              {status?.user && (
                                <span>
                                  Admin has set the status of{" "}
                                  <strong>{status.user}</strong>
                                  {status?.status && (
                                    <>
                                      {" "}
                                      to{" "}
                                      <span className="text-yellow-600">
                                        {status.status}
                                      </span>
                                    </>
                                  )}
                                </span>
                              )}

                              {status?.reason &&
                                status.status !== "active" &&
                                status.status !== "register" && (
                                  <span>reason: {status.reason}</span>
                                )}

                              {statusType === "changed" &&
                                statuschangeddate && (
                                  <span>
                                    changed at:{" "}
                                    <strong>
                                      {new Date(
                                        statuschangeddate,
                                      ).toLocaleDateString()}
                                    </strong>
                                  </span>
                                )}

                              {statusType === "updated" && statusupdatedate && (
                                <span>
                                  updated at:{" "}
                                  <strong>
                                    {new Date(
                                      statusupdatedate,
                                    ).toLocaleDateString()}
                                  </strong>
                                </span>
                              )}
                            </div>
                          </td>
                          {/* Active data */}
                          <td className="px-4 py-4 text-sm text-gray-900">
                            <div className="flex flex-col gap-1">
                              {active && (
                                <span>
                                  Admin{" "}
                                  <span
                                    className={
                                      activeType === "accepted"
                                        ? "text-green-600"
                                        : "text-red-600"
                                    }
                                  >
                                    {activeType === "rejected"
                                      ? "declined"
                                      : "activated"}
                                  </span>{" "}
                                  the user <strong>{active.name}</strong>
                                </span>
                              )}

                              {activeType === "accepted" && activedate && (
                                <span>
                                  Activated at:{" "}
                                  <strong>
                                    {new Date(activedate).toLocaleDateString()}
                                  </strong>
                                </span>
                              )}
                              {activeType === "rejected" &&
                                active?.rejectedComment && (
                                  <span>
                                    Reason:{" "}
                                    <strong>{active.rejectedComment}</strong>
                                  </span>
                                )}
                              {activeType === "rejected" && rejectdate && (
                                <span>
                                  Declined at:{" "}
                                  <strong>
                                    {new Date(rejectdate).toLocaleDateString()}
                                  </strong>
                                </span>
                              )}
                            </div>
                          </td>
                          {/* Note data */}
                          <td className="px-4 py-4 text-sm text-gray-900">
                            <div className="flex flex-col gap-1">
                              {note?.user && (
                                <span>
                                  Admin added note for{" "}
                                  <strong>{note?.user}</strong>{" "}
                                </span>
                              )}
                              {note?.notes && (
                                <span className=" text-yellow-600">
                                  {note?.notes}
                                </span>
                              )}
                              {note?.status && (
                                <span>status: {note?.status}</span>
                              )}
                              {note?.communication && (
                                <span>
                                  communication: {note?.communication}
                                </span>
                              )}
                              {note?.purpose && (
                                <span>purpose: {note.purpose}</span>
                              )}
                              {notedate && (
                                <span>
                                  Note date:{" "}
                                  <strong>
                                    {new Date(notedate).toLocaleDateString()}
                                  </strong>
                                </span>
                              )}
                            </div>
                          </td>
                          {/* Tasknote data */}
                          <td className="px-4 py-4 text-sm text-gray-900">
                            <div className="flex flex-col gap-1">
                              <span>
                                {task ? (
                                  <>
                                    Admin added tasknote{" "}
                                    <strong>{task.notes}</strong>
                                  </>
                                ) : (
                                  ""
                                )}
                              </span>

                              <span>
                                {tasknote ? (
                                  <>
                                    {" "}
                                    Tasknote date:
                                    <strong>
                                      {new Date(tasknote).toLocaleDateString()}
                                    </strong>
                                  </>
                                ) : (
                                  ""
                                )}
                              </span>
                            </div>
                          </td>
                          {/* Marital data */}
                          <td className="px-4 py-4 text-sm text-gray-900">
                            <div className="flex flex-col gap-1">
                              {marry && (
                                <span>
                                  Admin has changed the marital status of{" "}
                                  <strong>{marry.user}</strong>
                                </span>
                              )}
                              {marry && (
                                <span>
                                  to <strong>{marry.maritalStatus}</strong>
                                </span>
                              )}
                              {marriedate && (
                                <span>
                                  Changed at:{" "}
                                  <strong>
                                    {new Date(marriedate).toLocaleDateString()}
                                  </strong>
                                </span>
                              )}
                            </div>
                          </td>
                          {/* Blocked data */}
                          <td className="px-4 py-4 text-sm text-gray-900">
                            <div className="flex w-full flex-col gap-1">
                              {block && (
                                <span>
                                  Admin has blocked{" "}
                                  <strong className=" text-red-600">
                                    {block.user}
                                  </strong>{" "}
                                  user
                                </span>
                              )}
                              {block && (
                                <span>
                                  for the reason <strong>{block.reason}</strong>
                                </span>
                              )}
                              {blockdate && (
                                <span>
                                  Blocked at:{" "}
                                  <strong>
                                    {new Date(blockdate).toLocaleDateString()}
                                  </strong>
                                </span>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <div className="mt-6 flex items-center justify-center space-x-2">
                <button
                  className="rounded bg-gray-200 px-3 py-1 hover:bg-gray-300 disabled:opacity-50"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((prev) => prev - 1)}
                >
                  Previous
                </button>
                <span className="text-sm">
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  className="rounded bg-gray-200 px-3 py-1 hover:bg-gray-300 disabled:opacity-50"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((prev) => prev + 1)}
                >
                  Next
                </button>
              </div>
            </div>
          ) : (
            <div className="py-6 text-center text-black">
              No data found for the selected admin.
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default AdminActivityLog;
